import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scrollup",
  "use": "icon-scrollup-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-scrollup\">\r\n  <path id=\"icon-scrollup_ic_up_web\" d=\"M15.167,21V16.333H7V11.667h8.167V7l7,7ZM14,2.333A11.667,11.667,0,1,1,2.333,14,11.68,11.68,0,0,1,14,2.333ZM14,0A14,14,0,1,0,28,14,14,14,0,0,0,14,0Z\" transform=\"translate(0 28) rotate(-90)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol